import { Component, Prop, Vue } from "vue-property-decorator";
import BottomModal from "@/components/bottomModal/bottomModal";
import Loading from "@/components/loading/loading";
import { localCurrency } from "@/plugins/currency";

@Component({
  components: {
    BottomModal,
    Loading,
  },
})
export default class SubscriptionsChangeProduct extends Vue {
  @Prop({ default: false }) show;
  @Prop({ default: null }) currentItem;

  isLoadingProducts = false;
  products = [];

  get getAvailableProducts() {
    let response = [];
    if (
      this.currentItem &&
      this.currentItem.menuItem &&
      this.currentItem.menuItem.products_details
    ) {
      response = [...this.currentItem.menuItem.products_details];
    }
    return response;
  }

  isCurrentProduct(product) {
    let response = false;
    if (
      this.currentItem &&
      this.currentItem.item &&
      this.currentItem.item &&
      this.currentItem.item.menu_items_product_id &&
      product &&
      product.id === this.currentItem.item.menu_items_product_id
    ) {
      response = true;
    }
    return response;
  }

  _onSelectProduct(product) {
    if (!this.isCurrentProduct(product)) {
      this.$emit("change-product", { ...product, over_cost: product.over_price });
    }
  }

  _money(value) {
    let response = "";
    if (value) {
      response = localCurrency(value);
    }
    return response;
  }
}
